// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nG-x","newExpiryDate":"styles_newExpiryDate__h_6IO","footer":"styles_footer__1Vh_F"};